import table_pot_img from "../../../../../../../../assets/games/Truco/Table_pot.webp"
import table_img from "../../../../../../../../assets/games/Truco/Table.webp"
import truco_table_img from "../../../../../../../../assets/games/Truco/Turco-table.webp"
import { memo } from "react"

export const TableSurface = memo(({ isPortrait }) => {
  return (
    <>
      <img
        // src={isPortrait ? table_pot_img : table_img}
        src={truco_table_img}
        className="truco-table"
        draggable="false"
      />


      {/* <div className="truco-table-main">
        <div className="truco-table-layer-1">
          <div className="truco-table-rim"></div>
          <div className="truco-table-layer-2">
            <div className="truco-table-layer-3"></div>
          </div>
        </div>
        <div className="truco-table-waterMark">TRUCO</div>
        </div> */}
      <div className="truco-table-waterMark">TRUCO</div>
      <div className="chair-l"></div>
      <div className="chair-r"></div>


      {/* <div class="table-container">
        <div class="t-wood">
          <div class="t-rim"></div>
          <div class="t-felt">
            <div class="felt-track"></div>
          </div>
        </div>
      </div> */}
    </>
  )
})